import { ReactNode } from "react";

type IndustryPillProps = {
    label: string;
    active?: boolean;
    icon?: string | ReactNode;
    onClick?: () => void;
  };
  
  export const IndustryPill = ({
    label,
    active = false,
    icon,
    onClick,
  }: IndustryPillProps) => {
    return (
      <div>
        <div className="hidden lg:block">
           <button
        type="button"
        onClick={onClick}
        className={`
          h-[46px] rounded-full px-4 flex items-center gap-2.5
          border transition-all duration-200 whitespace-nowrap
          hover:scale-105
          transition
          ${
            active
              ? "bg-[linear-gradient(90deg,#FF0000_0%,#990000_100%)] text-white border-white/60 shadow-[0px_8px_24px_rgba(0,0,0,0.12)]"
              : "bg-white text-[#1A1A1A] border-white/70 shadow-[0px_6px_20px_rgba(0,0,0,0.08)] hover:bg-[#fff5f5]"
          }
        `}
      >
        {typeof icon === "string" ? (
  <img
    src={icon}
    alt=""
    className={`w-[18px] h-[18px] object-contain ${active ? "brightness-0 invert" : ""}`}
    aria-hidden="true"
  />
) : (
  <span className={`${active ? "[&_*]:brightness-0 [&_*]:invert" : ""}`} aria-hidden="true">
    {icon}
  </span>
)}
  
        <span className="text-[16px] font-medium leading-none">{label}</span>
      </button>
        </div>


        <div className="block lg:hidden">
           <button
        type="button"
        onClick={onClick}
        className={`
          h-[32px] rounded-full px-5 flex items-center gap-1.5
          border transition-all duration-200 whitespace-nowrap
          ${
            active
              ? "bg-[linear-gradient(90deg,#FF0000_0%,#990000_100%)] text-white border-white/60 shadow-[0px_8px_24px_rgba(0,0,0,0.12)]"
              : "bg-white text-[#1A1A1A] border-white/70 shadow-[0px_6px_20px_rgba(0,0,0,0.08)] hover:bg-[#fff5f5]"
          }
        `}
      >
        {typeof icon === "string" ? (
  <img
    src={icon}
    alt=""
    className={`w-[12px] h-[12px] object-contain ${active ? "brightness-0 invert" : ""}`}
    aria-hidden="true"
  />
) : (
  <span className={`${active ? "[&_*]:brightness-0 [&_*]:invert" : ""}`} aria-hidden="true">
    {icon}
  </span>
)}
  
        <span className="text-[12px] font-medium leading-none">{label}</span>
      </button>
        </div>
      </div>
     
    );
  };